module.exports = __webpack_public_path__ + "static/img/news2_img.f6675d5.png";